// extracted by mini-css-extract-plugin
export default {"nav":"social-media-bar-styles__nav","btn":"social-media-bar-styles__btn"};